import { render, staticRenderFns } from "./-oz-rich-popover-modal.vue?vue&type=template&id=37556738&"
import script from "./-oz-rich-popover-modal.vue?vue&type=script&lang=ts&"
export * from "./-oz-rich-popover-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports